package amazon.lastmile.inject

import app.nestbridge.feature.invitations.presentation.InvitationDetailPresenterFactory
import com.slack.circuit.runtime.presenter.Presenter
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = InvitationDetailPresenterFactory::class)
public interface AppNestbridgeFeatureInvitationsPresentationInvitationDetailPresenterFactory {
  @Provides
  @IntoSet
  public fun provideInvitationDetailPresenterFactoryFactoryMultibinding(invitationDetailPresenterFactory: InvitationDetailPresenterFactory): Presenter.Factory = invitationDetailPresenterFactory
}
